import styled from "styled-components";
import { SPACING } from "../../../utils/constants";

export const Container = styled.div<{ $height: number }>`
  position: relative;
  width: 100%;
  height: ${(p) => p.$height}px;
  border-radius: 8px;
  overflow: hidden;
`;

export const Cell = styled.div`
  position: absolute;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: ${SPACING.sm + SPACING.xxs}px;
  cursor: default;
  transition: filter 0.15s ease-out;

  &:hover {
    filter: brightness(1.12);
  }
`;

export const CellInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.xxs}px;
`;

export const CellName = styled.span`
  font-family: "Crimson Pro", sans-serif;
  font-size: var(--text-sm);
  font-weight: 600;
  color: #fff;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CellValue = styled.span`
  font-family: "Crimson Pro", sans-serif;
  font-size: var(--text-xs);
  font-weight: 400;
  color: rgba(255, 255, 255, 0.82);
  line-height: 1.2;
`;

export const CellPct = styled.span`
  font-family: "Crimson Pro", sans-serif;
  font-size: var(--text-xs);
  font-weight: 400;
  color: rgba(255, 255, 255, 0.65);
  letter-spacing: 0.02em;
  line-height: 1.2;
`;

export const TitleEl = styled.h3`
  margin: 0 0 ${SPACING.sm + SPACING.xs}px 0;
  color: var(--color-text-default);
  font-family: "Crimson Pro", sans-serif;
  font-size: var(--text-md);
  font-weight: 600;
  letter-spacing: -0.005em;
`;

export const EmptyState = styled.p`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
  text-align: center;
  color: var(--color-text-secondary);
  font-family: "Crimson Pro", sans-serif;
`;
